import { render, staticRenderFns } from "./trainConect.vue?vue&type=template&id=28454477&scoped=true"
import script from "./trainConect.vue?vue&type=script&lang=js"
export * from "./trainConect.vue?vue&type=script&lang=js"
import style0 from "./trainConect.vue?vue&type=style&index=0&id=28454477&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28454477",
  null
  
)

export default component.exports